import ConvalidaResetPassword from "../../components/ConfermaResetPassword/ConvalidaResetPassword";


export default function ConfermaResetPassword() {
    
    return (
        <ConvalidaResetPassword />
    );
}